<template>
  <div id="Zbcp">
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item label="区域：">
          <el-cascader
            placeholder="--选择区域--"
            size="large"
            :options="options"
            v-model="queryForm.region"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="经销商名称：">
          <el-input v-model.trim="queryForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="经销商ID：">
          <el-input type="number" v-model="queryForm.id" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
          <el-button type="primary" @click="getTableData">导出表格</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="content">
        <el-table :data="tableData" style="width: 100%" ref="table">
          <el-table-column prop="id" label="编号" key="id"></el-table-column>
          <el-table-column
            prop="name"
            label="经销商名称"
            key="name"
          ></el-table-column>
          <el-table-column
            prop="contact"
            label="联系人"
            key="contact"
          ></el-table-column>
          <el-table-column
            prop="phoneNumber"
            label="联系电话"
            key="phoneNumber"
          ></el-table-column>
          <el-table-column
            prop="username"
            label="账号"
            key="username"
          ></el-table-column>
          <el-table-column
            prop="regionName"
            label="经销商地区"
            key="regionName"
          ></el-table-column>
          <el-table-column
            prop="fullAddress"
            label="详细地址"
            key="fullAddress"
          ></el-table-column>
          <el-table-column
            label="创建时间"
            prop="createdAt"
            key="createdAt"
          ></el-table-column>
          <el-table-column prop="status" key="status" label="状态" width="120">
            <template slot-scope="scope">
              {{
                scope.row.status == 0
                  ? "禁用"
                  : scope.row.status == 1
                  ? "启用"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column width="180" prop label="操作">
            <template slot-scope="scope">
              <!-- <el-switch
                v-model="scope.row.status"
                active-text-color="#13CE66"
                inactive-text-color="#13CE66"
                active-color="#13CE66"
                inactive-color="#13CE66"
                active-text="禁用"
                inactive-text="启用"
                active-value="0"
                inactive-value="1"
                @change="modify(scope.$index, scope.row)"
              >
              </el-switch> -->
              <span @click="bj(scope.$index, scope.row)" class="btns"
                >编辑</span
              >

              <span @click="sc(scope.$index, scope.row)" class="btns"
                >删除</span
              >
              <span @click="cz(scope.$index, scope.row)" class="btns"
                >重置密码</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="button">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          @current-change="current_change"
          :current-page="currentPage"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改经销商"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item label="经销商名称：" prop="name">
          <el-input v-model.trim="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="经销商地区：" prop="region">
          <el-cascader
            placeholder="--选择区域--"
            size="large"
            :options="options"
            v-model="editForm.region"
            @change="handleRegionChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：" prop="fullAddress">
          <el-input v-model.trim="editForm.fullAddress"></el-input>
        </el-form-item>
        <el-form-item label="账号：" prop="username">
          <el-input v-model.trim="editForm.username"></el-input>
        </el-form-item>
        <!-- <el-form-item label="密码：" prop="password">
          <el-input v-model.trim="editForm.password"></el-input>
        </el-form-item> -->
        <el-form-item label="联系人：" prop="contact">
          <el-input v-model.trim="editForm.contact"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phoneNumber">
          <el-input
            type="number"
            :maxlength="11"
            oninput="if(value.length>11)value=value.slice(0,11)"
            v-model.trim="editForm.phoneNumber"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="handleUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加经销商"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="120px"
        ref="newForm"
        :rules="rules"
      >
        <el-form-item label="经销商名称：" prop="name">
          <el-input v-model.trim="newForm.name"></el-input>
        </el-form-item>
        <el-form-item label="经销商地区：" prop="region">
          <el-cascader
            placeholder="--选择区域--"
            size="large"
            :options="options"
            v-model="newForm.region"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：" prop="fullAddress">
          <el-input v-model.trim="newForm.fullAddress"></el-input>
        </el-form-item>
        <el-form-item label="账号：" prop="username">
          <el-input v-model.trim="newForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input v-model.trim="newForm.password"></el-input>
        </el-form-item>
        <el-form-item label="联系人：" prop="contact">
          <el-input v-model.trim="newForm.contact"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phoneNumber">
          <el-input
            type="number"
            :maxlength="11"
            oninput="if(value.length>11)value=value.slice(0,11)"
            v-model.trim="newForm.phoneNumber"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 修改密码 -->
    <el-dialog
      title="修改密码"
      :visible.sync="editPasswordVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handlePassClose"
    >
      <el-form
        :model="editPasswordForm"
        label-width="120px"
        ref="editPasswordForm"
        :rules="rules"
        status-icon
        class="demo-ruleForm"
      >
        <el-form-item label="密码" prop="pass">
          <el-input
            type="password"
            v-model="editPasswordForm.pass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
            type="password"
            v-model="editPasswordForm.checkPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="UpassCancel('editPasswordForm')"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click.native="UpdatePassWord('editPasswordForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getYYS } from "./../axios/api";
import areaData from "../utils/china-area.json";
import moment from "dayjs";
import { writeFile } from "../utils/xlsx";

export default {
  name: "Yys",
  data() {
    return {
      options: areaData, // 城市信息
      editPasswordVisible: false, //密码弹框
      editFormVisible: false, //弹框
      editPasswordForm: {
        pass: "",
        checkPass: ""
      },
      newData: false, //弹框
      editForm: {
        name: "",
        region: "",
        fullAddress: "",
        username: "",
        password: "",
        contact: "",
        phoneNumber: ""
      }, //弹框数据
      queryForm: {
        name: "",
        region: ""
      },
      newForm: {
        name: "",
        region: "",
        fullAddress: "",
        username: "",
        password: "",
        contact: "",
        phoneNumber: ""
      },
      loading: true,
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      tableData: [],
      eTableData: [], // 导出的数据
      eTabelLoading: false, //
      rules: {
        region: [{ required: true, message: "请选择地区", trigger: "change" }],
        fullAddress: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        name: [
          { required: true, message: "请输入经销商名字", trigger: "blur" }
        ],
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        phoneNumber: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ],
        pass: [{ required: true, message: "请输入密码", trigger: "blur" }],
        checkPass: [{ required: true, message: "请确认密码", trigger: "blur" }]
      }
    };
  },
  watch: {
    eTableData(newVal) {
      // console.log(newVal.length,this.total)
      if (newVal.length === this.total) {
        this.exprotData();
      }
    }
  },
  methods: {
    exprotData() {
      // 获取导出数据
      // this.getTableData();
      if (this.eTableData.length === this.total) {
        //
        this.eTabelLoading = false;
        this.$message({
          type: "success",
          message: "导出成功！"
        });
        //
        const SheetHeader = [
          { key: "id", label: "编号" },
          { key: "name", label: "经销商名称" },
          { key: "contact", label: "联系人" },
          { key: "phoneNumber", label: "联系电话" },
          { key: "username", label: "账号" },
          { key: "regionName", label: "经销商地区" },
          { key: "fullAddress", label: "详细地址" },
          {
            key: "status",
            label: "状态",
            render: value => ["禁用", "启用"][value]
          },
          { key: "createdAt", label: "创建时间" }
        ];
        writeFile(
          this.eTableData,
          SheetHeader,
          `经销商数据${moment(new Date()).format("YYYY-MM-DD")}`
        );
      }
    },
    //
    getTableData() {
      var that = this;
      that.eTabelLoading = true;
      this.$message({
        type: "warning",
        message: "正在导出请稍后！",
      });

      //获取经销商列表
      let data = {
        id: that.queryForm.id ? Number(that.queryForm.id) : undefined,
        name: that.queryForm.name ? that.queryForm.name : undefined,
        region: that.queryForm.region
          ? that.queryForm.region.join("")
          : undefined,
        pageNumber: 1,
        pageSize: 99999
      };
      // console.log(data)
      getYYS.getTable(data).then(function(res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定"
          });
        } else {
          let { list } = res.data;

          list.map(lis => {
            let addr = "";
            let province = lis.region.slice(0, 2);
            let town = lis.region.slice(2, 6);
            let district = lis.region.slice(6, 12);

            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );

            that.options.map(item1 => {
              if (item1.value === province) {
                addr += item1.label;
                item1.children.map(item2 => {
                  if (item2.value === town) {
                    addr += item2.label;
                    item2.children.map(item3 => {
                      if (item3.value === district) {
                        addr += item3.label;
                      }
                    });
                  }
                });
              }
            });

            lis.regionName = addr;
          });

          that.eTableData = list;
        }
      });
    },
    // 修改密码取消
    UpassCancel(formName) {
      this.editPasswordVisible = false;
      this.editPasswordForm = {};
    },
    UpdatePassWord(forName) {
      var that = this;
      this.$refs["editPasswordForm"].validate(valid => {
        if (valid) {
          if (that.editPasswordForm.checkPass !== that.editPasswordForm.pass) {
            that.$message.error("两次输入密码不一致!");
          } else {
            let data = {
              password: that.editPasswordForm.checkPass
            };
            getYYS
              .editTable(data, that.editPasswordForm.id)
              .then(function(res) {
                if (res.code !== 0) {
                  that.$alert(res.message, "提示", {
                    confirmButtonText: "确定"
                  });
                } else {
                  that.$message({
                    type: "success",
                    message: "密码更新成功!"
                  });
                  that.editPasswordVisible = false;
                  that.$refs["editPasswordForm"].resetFields();
                  that.init();
                }
              })
              .catch(function(res) {
                that.editPasswordVisible = false;
                that.$refs["editPasswordForm"].resetFields();
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定"
                });
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleRegionChange(value) {
      console.log(value);
    },
    handleChange(file, fileList) {
      this.fileTemp = file.raw;
      console.log(this.fileTemp);
    },
    handleRemove(file, fileList) {
      this.fileTemp = null;
    },
    up: function() {
      if (this.fileTemp) {
        if (
          this.fileTemp.type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          this.fileTemp.type == "application/vnd.ms-excel"
        ) {
          this.importfxx(this.fileTemp);
          this.fileTemp = null;
        } else {
          this.$message({
            type: "warning",
            message: "附件格式错误，请删除后重新上传！"
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请上传附件！"
        });
      }
    },
    down: function() {
      var FileSaver = require("file-saver");
      FileSaver.saveAs(
        "https://nkdpdi.nkodapu.com/pdi/files/经销商模板.xlsx",
        "经销商模板"
      );
    },
    trim(str) {
      console.log(typeof str);
      return (str = str.replace(/^\s+|\s+$/g, ""));
    },
    importfxx(obj) {
      let that = this;
      // 通过DOM取文件数据
      this.file = obj;
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;
      var reader = new FileReader();
      //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function(f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function(e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64"
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary"
            });
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); //outdata就是你想要的东西
          console.log(outdata);
          outdata.map(function(item) {
            console.log(Object.keys(item));
            Object.keys(item).map(res => {
              item[res] = item[res].toString();
              console.log(that.trim(item[res]));
              item[res] = that.trim(item[res]);
              console.log(item[res]);
            });
            item.Province = item.省 ? item.省.toString() : "";
            item.City = item.市 ? item.市.toString() : "";
            item.County = item.区 ? item.区.toString() : "";
            item.Address = item.详细地址 ? item.详细地址.toString() : "";
            item.Name = item.经销商名称 ? item.经销商名称.toString() : "";
            item.Account = item.经销商账号 ? item.经销商账号.toString() : "";
            item.ContactName = item.联系人 ? item.联系人.toString() : "";
            item.ContactNumber = item.联系电话 ? item.联系电话.toString() : "";
            item.Type = 1;
            delete item.省;
            delete item.市;
            delete item.区;
            delete item.详细地址;
            delete item.经销商名称;
            delete item.经销商账号;
            delete item.联系人;
            delete item.联系电话;
            //   that.tableData.unshift(item)
          });
          console.log(outdata);

          getYYS
            .AddPartners(outdata)
            .then(function(res) {
              // console.log(res)
              that.$message({
                type: "success",
                message: "添加成功!"
              });
              that.init();
              that.$refs.upload.clearFiles(); //清空
            })
            .catch(function(res) {
              that.editFormVisible = false;
              // console.log(res)
              that.$alert(res + "!", "提示", {
                confirmButtonText: "确定"
              });
              that.$refs.upload.clearFiles(); //清空
            });
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    modify(index, row) {
      console.log(row.status);
      if (row.status == 1) {
        this.handleSwitch(row.status, row.id);
      } else if (row.status == 0) {
        this.handleSwitch(row.status, row.id);
      }
    },
    handleSwitch(value, id) {
      console.log(value, id);
      let data = {
        status: Number(value)
      };
      getYYS
        .editTable(data, id)
        .then(function(res) {
          if (res.code !== 0) {
            that.$alert(res.message, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            that.$message({
              type: "success",
              message: "状态成功!"
            });
            that.init();
          }
        })
        .catch(function(res) {});
    },

    search: function() {
      this.currentPage = 1;
      this.init();
    },
    reset: function() {
      (this.queryForm.name = ""),
        (this.queryForm.region = ""),
        (this.currentPage = 1),
        this.init();
    },
    add: function() {
      this.newData = true; //显示弹框
      this.imgList = [];
    },
    //点击关闭dialog
    newClose(done) {
      this.newData = false;
      this.$refs["newForm"].resetFields();
    },
    //点击取消
    newCancel(formName) {
      this.newData = false;
      this.$refs["newForm"].resetFields();
    },
    //点击添加
    newUpdate(forName) {
      var that = this;
      this.$refs["newForm"].validate(valid => {
        if (valid) {
          let region = that.newForm.region.join("");
          var data = {
            name: that.newForm.name,
            region: region,
            fullAddress: that.newForm.fullAddress,
            contact: that.newForm.contact,
            phoneNumber: that.newForm.phoneNumber,
            username: that.newForm.username,
            password: that.newForm.password
          };
          // console.log(data);
          //这里再向后台发个post请求重新渲染表格数据

          getYYS
            .addTable(JSON.stringify(data))
            .then(function(res) {
              if (res.code !== 0) {
                that.$alert(res.message, "提示", {
                  confirmButtonText: "确定"
                });
              } else {
                that.$message({
                  type: "success",
                  message: "添加成功!"
                });
                that.newData = false;
                (that.newForm = {}), that.$refs["newForm"].resetFields();
                that.currentPage = 1;
                that.init();
              }
            })
            .catch(function(res) {
              console.log(res);
              //清空
              that.newForm = {};
              that.newData = false;
              that.$refs["newForm"].resetFields();
              that.$alert(res.message, "提示", {
                confirmButtonText: "确定"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    current_change: function(currentPage) {
      this.currentPage = currentPage;
      this.init();
    },

    //点击编辑
    bj: function(index, row) {
      var that = this;
      this.editFormVisible = true; //显示弹框
      that.editForm.name = row.name;
      that.editForm.id = row.id;

      // 区域
      let province = row.region.slice(0, 2);
      let town = row.region.slice(2, 6);
      let district = row.region.slice(6, 12);
      that.editForm.region = [province, town, district];

      that.editForm.fullAddress = row.fullAddress;
      that.editForm.phoneNumber = row.phoneNumber;
      that.editForm.username = row.username;
      that.editForm.contact = row.contact;
    },
    //点击关闭dialog
    handleClose(done) {
      this.editFormVisible = false;
      this.$refs["editForm"].resetFields();
    },
    handlePassClose() {
      this.editPasswordVisible = false;
      this.$refs["editPasswordForm"].resetFields();
      this.editPasswordForm = {};
    },
    //点击取消
    handleCancel(formName) {
      this.editFormVisible = false;
      this.$refs["editForm"].resetFields();
    },
    //点击更新
    handleUpdate(forName) {
      var that = this;
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          let region = that.editForm.region.join("");
          var data = {
            name: that.editForm.name,
            region: region,
            fullAddress: that.editForm.fullAddress,
            contact: that.editForm.contact,
            phoneNumber: that.editForm.phoneNumber,
            username: that.editForm.username
          };
          //这里再向后台发个post请求重新渲染表格数据

          getYYS
            .editTable(data, that.editForm.id)
            .then(function(res) {
              if (res.code !== 0) {
                that.$alert(res.message, "提示", {
                  confirmButtonText: "确定"
                });
              } else {
                that.$message({
                  type: "success",
                  message: "更新成功!"
                });
                that.editFormVisible = false;
                that.$refs["editForm"].resetFields();
                that.init();
              }
            })
            .catch(function(res) {
              that.editFormVisible = false;
              that.$refs["editForm"].resetFields();
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //更新的时候就把弹出来的表单中的数据写到要修改的表格中

      // console.log(data)
    },
    //点击删除
    sc: function(index, row) {
      console.log(row);
      var that = this;
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          getYYS
            .delTable({
              id: row.id
            })
            .then(function(res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定"
                });
              } else {
                that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }
            })
            .catch(function(res) {
              that.$message({
                type: "info",
                message: res.message
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    cz: function(index, row) {
      this.editPasswordVisible = true;
      // 密码
      this.editPasswordForm.id = row.id;
    },

    init: function() {
      var that = this;

      //获取经销商列表
      let data = {
        id: that.queryForm.id ? Number(that.queryForm.id) : undefined,
        name: that.queryForm.name ? that.queryForm.name : undefined,
        region: that.queryForm.region
          ? that.queryForm.region.join("")
          : undefined,
        pageNumber: that.currentPage,
        pageSize: that.pagesize
      };
      // console.log(data)
      getYYS.getTable(data).then(function(res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定"
          });
        } else {
          let { list, totalNumber } = res.data;

          list.map(lis => {
            let addr = "";
            let province = lis.region.slice(0, 2);
            let town = lis.region.slice(2, 6);
            let district = lis.region.slice(6, 12);

            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );

            that.options.map(item1 => {
              if (item1.value === province) {
                addr += item1.label;
                item1.children.map(item2 => {
                  if (item2.value === town) {
                    addr += item2.label;
                    item2.children.map(item3 => {
                      if (item3.value === district) {
                        addr += item3.label;
                      }
                    });
                  }
                });
              }
            });

            lis.regionName = addr;
          });

          that.tableData = list;
          that.total = totalNumber;
          that.loading = false;
        }
      });
    }
  },
  mounted() {
    var that = this;
    that.init();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/page/Yys.vue